<div *ngIf="showDevHeader" class="fixed top-0 z-999 w-full bg-amber-500 text-xs font-monospace flex flex-col items-center opacity-80">Development Version</div>
<div *ngIf="showImpersonationHeader" class="fixed top-0 z-999 w-full bg-purple-600 text-white text-xs font-monospace flex items-center justify-center gap-4 py-1">
    <span>Impersonating <strong>{{ currentUser?.displayName || currentUser?.username }}</strong> (as admin: {{ currentUser?.impersonation?.originalAdminUsername }})</span>
    <button 
        (click)="exitImpersonation()" 
        class="px-3 py-0.5 bg-white text-purple-600 rounded hover:bg-purple-100 font-semibold transition-colors">
        Exit Impersonation
    </button>
</div>
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'" [dir]="direction"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
<centered-layout *ngIf="layout === 'centered'"></centered-layout>

<!-- Enterprise -->
<enterprise-layout *ngIf="layout === 'enterprise'"></enterprise-layout>

<!-- Material -->
<material-layout *ngIf="layout === 'material'"></material-layout>

<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<!-- Classy -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<!-- Compact -->
<compact-layout *ngIf="layout === 'compact'"></compact-layout>

<!-- Dense -->
<dense-layout *ngIf="layout === 'dense'"></dense-layout>

<!-- Futuristic -->
<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>

<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'"></thin-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<settings *ngIf="environment.production === false"></settings>
